
import React from "react";
import { cn } from "@/lib/utils";

export type LogoVariant = "default" | "transparent" | "story";
export type LogoSize = "xs" | "sm" | "md" | "lg" | "xl";

interface LogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

const sizeMap: Record<LogoSize, string> = {
  xs: "w-5 h-5",
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-12 h-12",
  xl: "w-20 h-20"
};

export const Logo: React.FC<LogoProps> = ({
  variant = "default",
  size = "md",
  className,
  showText = true,
  textClassName
}) => {
  const logoSrc = 
    variant === "transparent" ? "/logo-transparent-svg.svg" :
    variant === "story" ? "/story-svg.svg" : 
    "/logo-svg.svg";
  
  const sizeClass = sizeMap[size];

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img 
        src={logoSrc} 
        alt="VirtuStaff.ai Logo" 
        className={cn(sizeClass)}
      />
      {showText && (
        <span className={cn("font-semibold text-xl", textClassName)}>
          VirtuStaff.ai
        </span>
      )}
    </div>
  );
};

export default Logo;
